exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-backdrop{background-color:rgba(24,32,40,.94)!important}.modal-dialog{max-width:600px}.modal-body{max-height:500px;overflow-y:scroll}.modal-header-button{margin-left:auto}.modal-header .close{margin:-1rem -1rem -1rem 0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-42601341","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/layout/Modal.vue
// module id = 457
// module chunks = 0